import type { NetworkInterceptorCapturedRequest } from './networkInterceptorParameterization';

function headersObjectToArray(
  headers: Record<string, string> | undefined | null
): Array<{ key: string; value: string }> {
  if (!headers || typeof headers !== 'object' || Array.isArray(headers)) return [];
  return Object.entries(headers).map(([key, value]) => ({
    key,
    value: String(value ?? ''),
  }));
}

function extractQueryParams(url: string): Array<{ key: string; value: string }> {
  try {
    const u = new URL(url);
    return Array.from(u.searchParams.entries()).map(([key, value]) => ({
      key,
      value,
    }));
  } catch {
    return [];
  }
}

/**
 * Converts NetworkTab request objects (from browser extension capture)
 * into the shape expected by `analyzeNetworkInterceptorRequests`.
 */
export function mapNetworkRequestsToInterceptorFormat(
  requests: any[]
): NetworkInterceptorCapturedRequest[] {
  return (requests || []).map((req) => {
    const hasPayload =
      req.requestPayload &&
      req.requestPayload !== '[No payload]' &&
      req.requestPayload !== null;

    let bodyString: string | null = null;
    if (hasPayload) {
      bodyString =
        typeof req.requestPayload === 'string'
          ? req.requestPayload
          : JSON.stringify(req.requestPayload);
    }

    return {
      uniqueId: req.id || String(Math.random()),
      reqApiUrl: req.fullUrl || '',
      reqMethod: req.method || 'GET',
      timestamp: req.startTime || req.timestamp,
      status: req.status,
      requestData: {
        reqApiUrl: req.fullUrl || '',
        reqMethod: req.method || 'GET',
        reqBody: {
          reqData: bodyString,
        },
        reqHeaders: headersObjectToArray(req.headers?.request),
        reqParams: extractQueryParams(req.fullUrl || ''),
      },
      responseData: {
        resHeaders: headersObjectToArray(req.headers?.response),
        responseBody: req.responseContent,
      },
    };
  });
}
